<template>
    <div
        ref="propbox"
        v-touch:swipe.right="swipetoright"
        v-touch:swipe.left="swipetoleft"
        v-bind:style="imgheight"
        style="overflow: hidden; position: relative;"
    >
        <div
            v-if="imageArray.length > 1"
            @click.prevent="swipe('right')"
            @mouseover="preload('right')"
            class="z-10 absolute cursor-pointer top-1/2 text-gray-100 text-opacity-75 text-3xl right-5 hover:text-white hover:text-opacity-100 icon-circle-right"
        ></div>
        <div
            v-if="imageArray.length > 1"
            @click.prevent="swipe('left')"
            @mouseover="preload('left')"
            class="z-10 absolute cursor-pointer top-1/2 text-gray-100 text-opacity-75 text-3xl left-5 hover:text-white hover:text-opacity-100 icon-circle-left"
        ></div>
        <transition-group
            name="slider"
            tag="div"
            v-on:after-enter="clearHeight"
        >
            <div v-for="number in [pointer]" :key="number">
                <picture>
                    <source type="image/webp" :alt="alt" :data-srcset="webpSrcset" data-sizes="auto"/>
                    <img
                        :alt="alt"
                        ref="currentimg"
                        class="propimg propertyImg lazyload"
                        @load="imageload"
                        src="https://images.simplyowners.net/assets/loading.jpg"
                        data-sizes="auto"
                        :data-srcset="currentsrcset"
                        :data-src="currentElement"
                        width="768"
                        height="597"
                        onerror="this.onerror=null;this.src='/images/awaiting_image.png';this.srcset='/images/awaiting_images_768.jpg 768w, /images/awaiting_images_400.jpg 400w,';"
                    />
                </picture>
            </div>
        </transition-group>
        <img
            v-if="currentsrc !== 0"
            class=""
            style="display: none;"
            :src="preloadsrcset"
        />
    </div>
</template>

<script>
export default {
    name: "SliderComponent",
    props: ["images", "pid", "thumb", "alt"],
    data() {
        return {
            pointer: 0,
            preloadpointer: 0,
            imageArray: this.images,
            show: false,
            imgheight: {},
            currentsrc: 0,
            currentType: "jpg",
            imageDomain: import.meta.env.VITE_PROPERTY_IMAGE_DOMAIN
        };
    },
    methods: {
        swipe(data) {
            //swipe the image left or right
            this.setHeight();
            if (data === "right") {
                this.pointer += 1;
            }
            if (data === "left") {
                this.pointer -= 1;
            }
            this.preload(data);
            this.storeSwipe(this.pid);
        },
        swipetoright() {
            //touch event to nav left
            this.swipe("left");
        },
        swipetoleft() {
            //touch event to nav right
            this.swipe("right");
        },
        storeSwipe(data) {
            axios.get(`/store-swipe/${data}`);
        },
        imageload() {
            // get the srcset of the current image for the preload

            if (this.$refs.currentimg[0] !== undefined) {
                if (this.$refs.currentimg[0].currentSrc.includes("_400.")) {
                    this.currentsrc = 400;
                } else if (
                    this.$refs.currentimg[0].currentSrc.includes("_768x576.")
                ) {
                    this.currentsrc = "768x576";
                }

                if (this.$refs.currentimg[0].currentSrc.endsWith(".jpg")) {
                    this.currentType = "jpg";
                } else if (
                    this.$refs.currentimg[0].currentSrc.endsWith(".webp")
                ) {
                    this.currentType = "webp";
                }
            }
        },
        setHeight() {
            // stops div collapsing on swipe
            let heightString = this.$refs.propbox.clientHeight + "px";
            Vue.set(this.imgheight, "height", heightString);
        },
        clearHeight() {
            // restores auto height after swipe
            Vue.set(this.imgheight, "height", "auto");
        },
        preload(data) {
            // preloads next image on hover of next button
            this.preloadpointer = this.pointer;
            if (data === "right") {
                this.preloadpointer += 1;
            }
            if (data === "left") {
                this.preloadpointer -= 1;
            }
        }
    },
    computed: {
        currentElement() {
            // default for browsers without src set
            return (
                this.imageDomain +
                "/properties/" +
                this.pid +
                "/" +
                this.pid +
                "_" +
                this.imageArray[
                    Math.abs(this.pointer) % this.imageArray.length
                ] +
                "_400.jpg"
            );
        },
        currentsrcset() {
            // src set image
            return (
                this.imageDomain +
                "/properties/" +
                this.pid +
                "/" +
                this.pid +
                "_" +
                this.imageArray[
                    Math.abs(this.pointer) % this.imageArray.length
                ] +
                "_768x576.jpg 768w, " +
                this.imageDomain +
                "/properties/" +
                this.pid +
                "/" +
                this.pid +
                "_" +
                this.imageArray[
                    Math.abs(this.pointer) % this.imageArray.length
                ] +
                "_400.jpg 400w"
            );
        },
        webpSrcset() {
            // src set image
            return (
                this.imageDomain +
                "/properties/" +
                this.pid +
                "/" +
                this.pid +
                "_" +
                this.imageArray[
                    Math.abs(this.pointer) % this.imageArray.length
                ] +
                "_768x576.webp 768w, " +
                this.imageDomain +
                "/properties/" +
                this.pid +
                "/" +
                this.pid +
                "_" +
                this.imageArray[
                    Math.abs(this.pointer) % this.imageArray.length
                ] +
                "_400.webp 400w"
            );
        },
        preloadsrcset() {
            // image to preload
            return (
                this.imageDomain +
                "/properties/" +
                this.pid +
                "/" +
                this.pid +
                "_" +
                this.imageArray[
                    Math.abs(this.preloadpointer) % this.imageArray.length
                ] +
                "_" +
                this.currentsrc +
                "." +
                this.currentType
            );
        }
    }
};
</script>
